import React from 'react';
import { PredictionCard } from './PredictionCard';
interface PredictionOption {
  id: number;
  text: string;
  probability: number;
  price: number;
}
interface Prediction {
  id: number;
  question: string;
  description: string;
  category: string;
  endDate: string;
  totalVolume: string;
  options: PredictionOption[];
  imageUrl: string;
}
interface PredictionsListProps {
  predictions: Prediction[];
  category?: string;
  limit?: number;
  featuredId?: number;
}
export const PredictionsList = ({
  predictions,
  category,
  limit = 8,
  featuredId
}: PredictionsListProps) => {
  let filteredPredictions = predictions;
  // Filter by category if provided
  if (category && category !== 'all') {
    filteredPredictions = predictions.filter(item => item.category === category);
  }
  // Filter out featured prediction if provided
  if (featuredId) {
    filteredPredictions = filteredPredictions.filter(item => item.id !== featuredId);
  }
  // Apply limit
  filteredPredictions = filteredPredictions.slice(0, limit);
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-257">
      {filteredPredictions.map(prediction => <PredictionCard key={prediction.id} id={prediction.id} question={prediction.question} description={prediction.description} category={prediction.category} endDate={prediction.endDate} totalVolume={prediction.totalVolume} options={prediction.options} imageUrl={prediction.imageUrl} data-id="element-258" />)}
    </div>;
};